// AIPlanCard — Itinerary card embedded inside an AI chat message.
// "Book this plan" CTA → notYetWiredToast.
// TODO(ai-API-PR): Wire "Book this plan" to real booking flow.

import { Plane, Building2 } from 'lucide-react';
import { notYetWiredToast } from './primitives';
import type { AIPlan } from '@/lib/ai-mock';

const T = {
  bg: '#FFF5EE', surface: '#FFFFFF', ink: '#1A0F08', inkDim: '#7A6657',
  primary: '#FF5A3C', accent: '#FFB800', soft: '#FFE3D2', chipInk: '#B5391C',
  line: 'rgba(26,15,8,0.08)',
  sans: '"Inter Variable","Inter",system-ui,sans-serif',
  display: '"Fraunces Variable","Fraunces",Georgia,serif',
};

interface AIPlanCardProps {
  plan: AIPlan;
}

export function AIPlanCard({ plan }: AIPlanCardProps) {
  return (
    <div style={{
      padding: 14, borderRadius: 18,
      background: T.bg, border: `1px solid ${T.line}`,
    }}>
      {/* header */}
      <div style={{
        fontFamily: T.sans, fontSize: 10, color: T.inkDim,
        letterSpacing: 1.5, fontWeight: 600, textTransform: 'uppercase',
        marginBottom: 10,
      }}>
        DRAFT ITINERARY · {plan.title.toUpperCase()}
      </div>

      {/* line items */}
      <div>
        {plan.items.map((item, i) => (
          <div
            key={i}
            style={{
              display: 'flex', alignItems: 'center', gap: 10,
              padding: '7px 0',
              borderBottom: i < plan.items.length - 1 ? `1px dashed ${T.line}` : 'none',
            }}
          >
            <div style={{
              width: 30, height: 30, borderRadius: 8,
              background: T.soft, display: 'flex', alignItems: 'center', justifyContent: 'center',
              flexShrink: 0,
            }}>
              {item.type === 'flight'
                ? <Plane size={14} stroke={T.chipInk} strokeWidth={1.8}/>
                : <Building2 size={14} stroke={T.chipInk} strokeWidth={1.8}/>
              }
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontFamily: T.sans, fontSize: 12, fontWeight: 600, color: T.ink }}>{item.label}</div>
              <div style={{ fontFamily: T.sans, fontSize: 10.5, color: T.inkDim, marginTop: 1 }}>{item.sub}</div>
            </div>
            <div style={{ fontFamily: T.sans, fontSize: 13, fontWeight: 700, color: T.ink }}>
              ₹{item.priceInr.toLocaleString('en-IN')}
            </div>
          </div>
        ))}
      </div>

      {/* total */}
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        marginTop: 10, paddingTop: 10, borderTop: `1px solid ${T.line}`,
      }}>
        <span style={{ fontFamily: T.sans, fontSize: 11, color: T.inkDim, fontWeight: 600 }}>
          TOTAL · {plan.budgetLabel.toUpperCase()}
        </span>
        <span style={{
          fontFamily: T.display, fontSize: 18, fontWeight: 600, color: T.ink,
        }}>₹{plan.totalInr.toLocaleString('en-IN')}</span>
      </div>

      {/* CTAs */}
      <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
        <button
          onClick={() => notYetWiredToast('AI Trip Planner')}
          style={{
            flex: 1, height: 40, borderRadius: 999,
            background: T.ink, color: '#FFF5EE', border: 'none',
            fontFamily: T.sans, fontSize: 12, fontWeight: 600, cursor: 'pointer',
            transition: 'opacity 200ms',
          }}
          onMouseEnter={e => { (e.currentTarget as HTMLButtonElement).style.opacity = '0.85'; }}
          onMouseLeave={e => { (e.currentTarget as HTMLButtonElement).style.opacity = '1'; }}
        >
          book this plan
        </button>
        <button
          onClick={() => notYetWiredToast('AI Trip Planner')}
          style={{
            height: 40, padding: '0 14px', borderRadius: 999,
            background: 'transparent', color: T.ink,
            border: `1px solid ${T.line}`,
            fontFamily: T.sans, fontSize: 12, fontWeight: 600, cursor: 'pointer',
          }}
        >
          tweak
        </button>
      </div>
    </div>
  );
}
